import { createAction, handleActions } from 'redux-actions'

const setActiveTab = createAction('SCREENS/PROJECT_VIEW/VALUATIONS/SET_ACTIVE_TAB')
const resetActiveTab = createAction('SCREENS/PROJECT_VIEW/VALUATIONS/RESET_ACTIVE_TAB')

const defaultState = 'valuations'

const reducer = handleActions(
  {
    [setActiveTab]: (state, { payload }) => payload,
    [resetActiveTab]: () => defaultState,
  },
  defaultState,
)

export { setActiveTab, resetActiveTab, reducer }
